<mat-card>
    <p>Esta cuenta ha sido deshabilitada anteriormente. ¿Deseas continuar con el pedido?</p>
    <div class="button-actions">
        <button mat-stroked-button type="button" (click)="closeCreateAccountDialog(false)">Cancelar</button>
        <app-submit (click)="closeCreateAccountDialog(true)">Pagar</app-submit>
    </div>
</mat-card>
